<template>
    <div class="search">
      <div class="search-bar">
        <i class="back-icon" @click="$router.go(-1)"></i>
        <Input v-model="searchVal" focus placeholder="Tap to search" @submit="search"/>
      </div>
      <div class="search-content">
        <template v-if="historyList.length">
          <h3 class="module-title">
            <span>Search History</span>
            <i @click="clearHistory" class="icon trash"></i>
          </h3>
          <div class="history-wrap">
            <p
              v-for="(val, index) in historyList"
              :key="val + index"
              class="search-tag"
              @click="historyClick(val)"
            >
              {{val}}
            </p>
          </div>
        </template>

        <!-- <h3 class="module-title">Hot Search</h3> -->
        <template v-if="searchList.length">
          <TitleBar title="Search Result" :needMore="false" />
          <div class="comics-list">
            <ComicsInfo
              v-for="item in searchList"
              :key="item.id"
              :info="item"
            />
          </div>
        </template>
        <template v-if="recommendList.length">
          <TitleBar title="Hot Comics" :needMore="false" />
          <div class="comics-list">
            <ComicsInfo
              v-for="item in recommendList"
              :key="item.id"
              :info="item"
            />
          </div>
        </template>

      </div>
    </div>
</template>

<script>
import { getSearchRecommend, searchNovel } from '@/api';
import { getItem, setItem } from '@/utils';

import TitleBar from '@/components/TitleBar.vue';
import Input from '@/components/Input.vue';
import ComicsInfo from '@/views/search/components/ComicsInfo';

const historyKey = 'search_history';
export default {
  components: { Input, ComicsInfo, TitleBar },
  data() {
    return {
      searchVal: '',
      historyList: [],
      searchList: [],
      recommendList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getRecommendList();
      this.getHistory();
    },
    getHistory() {
      this.historyList = getItem(historyKey) || [];
    },
    addHistory(val) {
      const i = this.historyList.findIndex((item) => item === val);
      if (i !== -1) this.historyList.splice(i, 1);
      this.historyList.unshift(val);
      this.historyList = this.historyList.slice(0, 10);
      setItem(historyKey, this.historyList);
    },
    clearHistory() {
      this.historyList = [];
      setItem(historyKey, []);
    },
    async getRecommendList() {
      const res = await getSearchRecommend();
      if (res.code !== 0) return;
      this.recommendList = res.data || [];
    },
    historyClick(val) {
      this.searchVal = val;
      this.search();
    },
    async search() {
      if (this.searchVal === '') return;
      this.addHistory(this.searchVal);
      const res = await searchNovel({ keyword: this.searchVal });
      if (res.code !== 0) return;
      this.searchList = res.data || [];
    },
  },
};
</script>

<style lang="less" scoped>
.search {
  // min-height: ;
  background-color: rgba(216, 238, 234, 1);

  .search-bar {
    display: flex;
    align-items: center;
    padding: 16px;
    height: 56px;
    margin-bottom: 4px;
    .back-icon {
      margin-right: 10px;
      .iconMixin({
        background-image: url('~@/assets/images/icon/back.png');
      });
    }
    /deep/ .input-wrap {
      flex: 1;
    }
  }
  .search-content {
    background-color: #fff;
    padding-top: 16px;
    border-radius: 12px 12px 0 0;
    .module-title {
      padding: 0 16px;
      height: 36px;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: @black;
      font-size: @fontMedium;
      .icon {
        .iconMixin();
        &.trash {
          background-image: url('@/assets/images/icon/trash.png');
        }
      }
    }

    .history-wrap {
      padding: 0 16px;
    }
  }

  .search-tag {
    display: inline-block;
    height: 24px;
    line-height: 24px;
    padding: 0 8px;
    border-radius: 12px;
    font-size: 16px;
    background-color: rgba(0, 0, 0, 0.05);
    color: @gray;
    margin: 0 8px 16px 0;
  }

  .comics-list {
    padding: 16px 16px 0;
  }

}

</style>
